'use client';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import ArrowLeftCircle from '@/components/icons/ArrowLeftCircle';
import Download from '@/components/icons/Navigation/Download';
import form from '@/styles/form.module.css';
import { FC, useRef } from 'react';
import styles from './page.module.css';
import useNavigate from '@/hooks/useNavigate';

const ImportRecap: FC<{
  files: { content: string; fileName: string }[];
  twoFiles?: boolean;
}> = ({ files, twoFiles = true }) => {
  const navigate = useNavigate();
  const hiddenLink = useRef<HTMLAnchorElement>(null);

  function onDownload() {
    files.forEach((file) => {
      const csv = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), file.content], {
        type: 'text/csv;charset=utf-8',
      });
      if (hiddenLink.current) {
        hiddenLink.current.download = file.fileName;
        hiddenLink.current.href = URL.createObjectURL(csv);
        hiddenLink.current.click();
      }
    });
  }

  return (
    <div className={`flex-column gap-l ${form.content}`}>
      <Button
        variant="ghost"
        icon={<ArrowLeftCircle />}
        onClick={() => navigate(-1)}
      >
        Retour
      </Button>
      <h3>Récapitulatif</h3>
      <Alert type="success" title={'Le fichier a bien été importé.'} />
      <Alert
        type="warning"
        message={
          'Assurez-vous d’avoir bien téléchargé les résultats. Vous ne pourrez les télécharger qu’une seule fois.'
        }
      />
      {twoFiles && (
        <Alert
          type="information"
          title={'Pourquoi 2 fichiers ?'}
          message={
            'Pour des soucis de sécurité, les identifiants et mots de passe sont dans 2 fichiers distincts.'
          }
        />
      )}
      <div className={styles['validate-container']}>
        <Button icon={<Download />} onClick={onDownload}>
          Télécharger les résultats
        </Button>
      </div>
      <a
        ref={hiddenLink}
        style={{ display: 'none' }} // Make the file input element invisible
      />
    </div>
  );
};

export default ImportRecap;
